<template>
    <div class="p1">
        <div class="flex-row m1 start top list border-end p1">
            <img src="/static/icon/tiku.png" alt="" style="width: 120px;height: 80px;">
            <div class="flex-column">
                <div class="flex-row f20b">{{ value.Name }}</div>
                <div class="flex-row f16g mt20">{{ value.CreateTime }}</div>
            </div>
        </div>
        <mx-page :key="config.Title + '考生列表'" type="Home" :config="config" :name="config.Title + '考生列表'"
            :title="config.Title + '考生列表'" theme="Panel" @event="OnEvent" :query="Query" v-if="config.Title + '考生列表'" :parent="value" :parent-type="config.Type">
        </mx-page>
    </div>
</template>

<script>
export default {
    props: {
        config: Object,
        value: Object
    },
    data() {
        return {

        }
    },
    computed: {
        Query() {
            return {
                "*": {
                    Parent: this.value
                }
            }
        }

    },
    methods: {
        OnEvent(e) {

        }
    }

}
</script>

<style scoped>
.mt20 {
    margin-top: 20px
}
</style>
